module.exports = __webpack_public_path__ + "06a68f623f7c99c8e9bc7ac5cca0a818.svg";